<script setup lang="ts">
import { useAgreementStore } from '@/stores/agreement';
import local from '@/stores/local';
import { useVehicleStore } from '@/stores/vehicle';
import type { ManualVehicle } from '@/types';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';

const { details, manualVehicle } = storeToRefs(useVehicleStore())
const { agreement } = storeToRefs(useAgreementStore())

const brand = computed(() => manualVehicle.value?.brand?.name ?? details.value?.brand)
const model = computed(() => manualVehicle.value?.model?.name ?? details.value?.model)
const engine = computed(() => manualVehicle.value?.engine?.name ?? details.value?.engine)
const registration = computed(() => {
  if (details.value) {
    return new Date(details.value.registrationYear, details.value.registrationMonth).toLocaleDateString('da-DK', { year: 'numeric', month: 'long' });
  }
  else if (agreement.value.registrationYear) {
    return agreement.value.registrationYear
  }
  else {
    return undefined
  }
})
</script>

<template>
  <v-slide-x-transition>
    <v-card
      v-if="brand || model || engine"
      :title="`${brand} ${model}`"
      append-icon="mdi-car-outline"
    >
      <v-card-text>
        <div v-if="details?.variant">{{ details.variant }}</div>
        <div>{{ engine }}</div>
        <div v-if="registration" class="text-capitalize">
          {{ registration }}
        </div>
        <div v-if="details?.serviceVinNumber">{{ details.serviceVinNumber }}</div>
      </v-card-text>
    </v-card>
  </v-slide-x-transition>
</template>